import { render, staticRenderFns } from "./GoldSchemeReport.vue?vue&type=template&id=37d1addc&scoped=true&"
import script from "./GoldSchemeReport.vue?vue&type=script&lang=js&"
export * from "./GoldSchemeReport.vue?vue&type=script&lang=js&"
import style0 from "./GoldSchemeReport.vue?vue&type=style&index=0&id=37d1addc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1addc",
  null
  
)

export default component.exports